import { render, staticRenderFns } from "./ApprovalMilk.vue?vue&type=template&id=e32a9682&scoped=true&"
import script from "./ApprovalMilk.vue?vue&type=script&lang=js&"
export * from "./ApprovalMilk.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalMilk.vue?vue&type=style&index=0&id=e32a9682&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32a9682",
  null
  
)

export default component.exports